import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-common-definition-list',
  templateUrl: './definition-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefinitionListComponent {
  @Input() title: string;
  @Input() colBreakpoint: string;
  @Input() colSize: number;

  defaultTitleClass = 'col-auto';
  defaultContentClass = 'col';

  get colSizeDiff(): number {
    return 12 - this.colSize;
  }

  get breakpointPrefix(): string {
    return this.colBreakpoint ? `${this.colBreakpoint}-` : '';
  }

  get titleClass(): string {
    return this.colSize
      ? `col-${this.breakpointPrefix}${this.colSize}`
      : this.defaultTitleClass;
  }

  get contentClass(): string {
    return this.colSize
      ? `col-${this.breakpointPrefix}${this.colSizeDiff}`
      : this.defaultContentClass;
  }
}
